function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GamePlayerboxTemplate = require('./game-playerbox.template');
var GamePlayerBox = require('./playerbox');
var GamePlayerbox = /*#__PURE__*/function () {
  function GamePlayerbox(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, GamePlayerbox);
    this.app = app;
    this.mod = mod;
    this.container = container || '.game-playerbox-manager';
    this.playerboxes = [];
    this.mode = 1; // 1 = normal - flex-container
    // 2 = poker mode
    // 3 = freestyle (no container)
  }
  return _createClass(GamePlayerbox, [{
    key: "render",
    value: function render() {
      //
      // create playerboxes to render
      //
      if (this.playerboxes.length < this.mod.game.players.length) {
        for (var i = 0; i < this.mod.game.players.length; i++) {
          this.playerboxes.push(new GamePlayerBox(this.app, this.mod, this.container, this.mod.game.players[i], i + 1));
        }
      }

      //
      // a local viewer without a seat (observer / pending table-joiner) gets a
      // box too -- the view seating chart deliberately leaves seat 1 open for
      // them. addressed as player_number 0 through the manager (returnBox).
      //
      if (!this.mod.game.players.includes(this.mod.publicKey) && this.playerboxes.length == this.mod.game.players.length) {
        this.playerboxes.push(new GamePlayerbox(this.app, this.mod, this.container, this.mod.publicKey));
      }

      //
      // insert container
      //
      if (this.mode != 3) {
        if (document.querySelector('.game-playerbox-manager')) {
          this.app.browser.replaceElementBySelector(GamePlayerboxTemplate(this.app, this.mod), '.game-playerbox-manager');
        } else {
          this.app.browser.addElementToSelectorOrDom(GamePlayerboxTemplate(this.app, this.mod), this.container);
        }
      }

      //
      // render playerboxes
      //
      for (var _i = 0; _i < this.playerboxes.length; _i++) {
        this.playerboxes[_i].render();
      }

      //
      // poker mode => add seating
      //
      if (this.mode == 2) {
        for (var _i2 = 1; _i2 <= this.playerboxes.length; _i2++) {
          var obj = document.querySelector(".game-playerbox-".concat(_i2));
          if (obj) {
            obj.classList.add("game-playerbox-seat-".concat(this.playerBox(_i2)));
          }
        }

        // the viewer box takes the open seat 1
        var viewer_box = document.querySelector('.game-playerbox-0');
        if (viewer_box) {
          viewer_box.classList.add('game-playerbox-seat-1');
        }
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      for (var i = 0; i < this.playerboxes.length; i++) {
        this.playerboxes[i].attachEvents();
      }
    }
  }, {
    key: "onclick",
    value: function onclick() {
      var _this$returnBox;
      var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var player_number = arguments.length > 1 ? arguments[1] : undefined;
      (_this$returnBox = this.returnBox(player_number)) === null || _this$returnBox === void 0 || _this$returnBox.onclick(fn);
    }
  }, {
    key: "hostVideo",
    value: function hostVideo() {
      var apply_to_all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      for (var i = 0; i < this.mod.game.players.length; i++) {
        if (this.mod.game.players[i] == this.mod.publicKey && !apply_to_all) {
          continue;
        }
        this.addClass('game-video-container', i + 1);
        this.addClass("gvc-".concat(this.mod.game.players[i]), i + 1);
      }
    }
  }, {
    key: "addClass",
    value: function addClass(content, player_number) {
      var _this$returnBox2;
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'game-playerbox';
      (_this$returnBox2 = this.returnBox(player_number)) === null || _this$returnBox2 === void 0 || _this$returnBox2.addClass(content, target);
    }

    //
    // resolve a player_number to its box. 0 = the local viewer's box (a
    // non-player observer / pending joiner).
    //
  }, {
    key: "returnBox",
    value: function returnBox(player_number) {
      if (player_number == 0) {
        return this.playerboxes.find(function (box) {
          return box.player_number == 0;
        }) || null;
      }
      if (player_number > 0 && this.playerboxes.length >= player_number) {
        return this.playerboxes[player_number - 1];
      }
      return null;
    }

    //
    // The body is all the dynamic content of the playerbox,
    // status, log, controls, etc.
    //
  }, {
    key: "updateBody",
    value: function updateBody(content, player_number) {
      var _this$returnBox3;
      if (!this.mod.gameBrowserActive()) {
        return;
      }
      (_this$returnBox3 = this.returnBox(player_number)) === null || _this$returnBox3 === void 0 || _this$returnBox3.updateBody(content);
    }

    //
    // Graphics exists outside of the playerbox (for a players hand)
    //
  }, {
    key: "updateGraphics",
    value: function updateGraphics(content, player_number) {
      var _this$returnBox4;
      (_this$returnBox4 = this.returnBox(player_number)) === null || _this$returnBox4 === void 0 || _this$returnBox4.updateGraphics(content);
    }
  }, {
    key: "replaceGraphics",
    value: function replaceGraphics(content, selector, player_number) {
      var _this$returnBox$repla, _this$returnBox5;
      return (_this$returnBox$repla = (_this$returnBox5 = this.returnBox(player_number)) === null || _this$returnBox5 === void 0 ? void 0 : _this$returnBox5.replaceGraphics(content, selector)) !== null && _this$returnBox$repla !== void 0 ? _this$returnBox$repla : null;
    }

    //
    // Address, Userline, Icons are all part of the playerbox header
    //
  }, {
    key: "updateAddress",
    value: function updateAddress(address, player_number) {
      var _this$returnBox6;
      (_this$returnBox6 = this.returnBox(player_number)) === null || _this$returnBox6 === void 0 || _this$returnBox6.updateAddress(address);
    }
  }, {
    key: "updateUserline",
    value: function updateUserline(userline, player_number) {
      var _this$returnBox7;
      (_this$returnBox7 = this.returnBox(player_number)) === null || _this$returnBox7 === void 0 || _this$returnBox7.updateUserline(userline);
    }
  }, {
    key: "updateIcons",
    value: function updateIcons(content, player_number) {
      var _this$returnBox8;
      (_this$returnBox8 = this.returnBox(player_number)) === null || _this$returnBox8 === void 0 || _this$returnBox8.updateIcons(content);
    }
  }, {
    key: "setActive",
    value: function setActive(player_number) {
      var deactivate_others = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      //
      // remove other active playerboxes
      //
      if (deactivate_others) {
        var qs2 = ".game-playerbox.active";
        var obj2 = document.querySelectorAll(qs2).forEach(function (el) {
          el.classList.remove('active');
        });
      }

      //
      // set as active
      //
      var qs = ".game-playerbox-".concat(player_number);
      var obj = document.querySelector(qs);
      if (obj) {
        obj.classList.add('active');
      }
    }
  }, {
    key: "setInactive",
    value: function setInactive() {
      var player_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      if (player_number == -1) {
        this.setActive(-1); // de-activate others, but won't set anything active
        return;
      }
      var qs = ".game-playerbox-".concat(player_number);
      var obj = document.querySelector(qs);
      if (obj) {
        obj.classList.remove('active');
      }
    }

    /**
     * Alert Next player with visual UI changes on player box. Done with predefined css classes
     * @param {int} pnum - the player number (according to game), -1 means this player
     * @param {string} alertType - the alert type that should be displayed  supported: 'flash', 'shake'
     * @param {string} stopTrigger - the browser event that should  stop an alert supported: 'click', 'mousemove'
     * @param {int} duration - the duration in milliseconds in which the alert should be displayed in the event of no stop trigger
     */
  }, {
    key: "alertPlayer",
    value: function alertPlayer() {
      var player_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      var alertType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flash';
      var stopTrigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 4000;
      var selector = ".game-playerbox-".concat(player_number);
      var box = document.querySelector(selector);
      if (box) {
        box.classList.add(alertType);
      }
      if (stopTrigger) {
        window.addEventListener(stopTrigger, function (e) {
          box.classList.remove(alertType);
        });
      } else {
        setTimeout(function () {
          box.classList.remove(alertType);
        }, duration);
      }
    }

    /**
     *
     * everything that follows is a support function that we do not want outside
     * elements to interact with...
     *
     * @param {int} pnum - player number, e.g. {1, 2, ... # of players}
     * Converts the player number to a "seat position" This player is always 1, unless you render with game.seats
     */
  }, {
    key: "playerBox",
    value: function playerBox(pnum) {
      //For attempts to access playerbox before rendered
      if (!this.mod) {
        return 1;
      }
      if (!this.mod.game.players.includes(this.mod.publicKey)) {
        var player_box = this.returnViewBoxArray();
        if (pnum <= 0) {
          return 1;
        }
        return player_box[pnum - 1];
      } else {
        var _player_box = this.returnPlayersBoxArray();
        if (pnum <= 0) {
          return _player_box[0]; //Default is first position
        }

        //Shift players in Box Array according to whose browser, so that I am always in seat 1
        var prank = 1 + this.mod.game.players.indexOf(this.mod.publicKey); //Equivalent to mod.player ?
        var seat = pnum - prank;
        if (seat < 0) {
          seat += this.mod.game.players.length;
        }
        return _player_box[seat];
      }
    }

    /**
     * Returns either game.seats or the default poker table seating schedule
     * 5 4 3
     * 6 1 2
     */
  }, {
    key: "returnPlayersBoxArray",
    value: function returnPlayersBoxArray() {
      var player_box = [];
      if (this.mod.game.players.length == 1) {
        player_box = [1];
      }
      if (this.mod.game.players.length == 2) {
        player_box = [1, 4];
      }
      if (this.mod.game.players.length == 3) {
        player_box = [1, 3, 5];
      }
      if (this.mod.game.players.length == 4) {
        player_box = [1, 3, 4, 5];
      }
      if (this.mod.game.players.length == 5) {
        player_box = [1, 2, 3, 5, 6];
      }
      if (this.mod.game.players.length == 6) {
        player_box = [1, 2, 3, 4, 5, 6];
      }
      return player_box;
    }

    /**
     * Returns poker table seating schedule for observer mode
     * 3 4 5
     * 2 _ 6
     */
  }, {
    key: "returnViewBoxArray",
    value: function returnViewBoxArray() {
      var player_box = [];
      if (this.mod.game.players.length == 1) {
        player_box = [4];
      }
      if (this.mod.game.players.length == 2) {
        player_box = [3, 5];
      }
      if (this.mod.game.players.length == 3) {
        player_box = [3, 4, 5];
      }
      if (this.mod.game.players.length == 4) {
        player_box = [2, 3, 5, 6];
      }
      if (this.mod.game.players.length == 5) {
        player_box = [2, 3, 4, 5, 6];
      }
      return player_box;
    }
  }, {
    key: "removeBoxes",
    value: function removeBoxes() {
      var _iterator = _createForOfIteratorHelper(this.playerboxes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var box = _step.value;
          box.remove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.playerboxes = [];
    }
  }]);
}();
module.exports = GamePlayerbox;